export type LegacyAuthPermission = {
  id: number
  authId: string
  name: string
  type: '페이지' | '기능'
  crud: 'C' | 'R' | 'U' | 'D'
  assignable: '' | 'O' | 'X'
  description: string
  active: boolean
  levels: number[]
  lastCalledAt: string
  createdAt: string
}

export const legacyAuthPermissions: LegacyAuthPermission[] = [
  {
    id: 1001,
    authId: 'MOCK_PAGE_READ',
    name: 'Mock 페이지 조회',
    type: '페이지',
    crud: 'R',
    assignable: '',
    description: '비식별 화면 조회 권한',
    active: true,
    levels: [1, 2, 7, 3],
    lastCalledAt: '2026-08-21 09:30:00',
    createdAt: '2026-08-01 10:00:00',
  },
  {
    id: 1002,
    authId: 'MOCK_ITEM_CREATE',
    name: 'Mock 항목 등록',
    type: '기능',
    crud: 'C',
    assignable: 'O',
    description: '비식별 항목 등록 권한',
    active: true,
    levels: [1, 2, 7],
    lastCalledAt: '-',
    createdAt: '2026-08-02 10:00:00',
  },
  {
    id: 1003,
    authId: 'MOCK_ITEM_DELETE',
    name: 'Mock 항목 삭제',
    type: '기능',
    crud: 'D',
    assignable: 'X',
    description: '비식별 항목 삭제 권한',
    active: false,
    levels: [1],
    lastCalledAt: '-',
    createdAt: '2026-08-03 10:00:00',
  },
]

export const legacyAuthLevels = [
  { value: 1, label: '1(시스템관리자)' },
  { value: 2, label: '2(브랜드관리자)' },
  { value: 7, label: '7(그룹관리자)' },
  { value: 3, label: '3(지점관리자)' },
  { value: 5, label: '5(일반)' },
  { value: 6, label: '6(TM담당자)' },
]
